// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"ModalHeader_closeButton__TiUfX"};